import { render, staticRenderFns } from "./leftBottom4.vue?vue&type=template&id=16f59bba&scoped=true"
import script from "./leftBottom4.vue?vue&type=script&lang=js"
export * from "./leftBottom4.vue?vue&type=script&lang=js"
import style0 from "./leftBottom4.vue?vue&type=style&index=0&id=16f59bba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f59bba",
  null
  
)

export default component.exports